<div class="modal-container">
  <h3 class="align-center">Delete</h3>
  <br>

  <div class="button-group">
    <button mat-flat-button class="btn-cancel" (click)="cancel()">Cancel</button>
    <button mat-flat-button class="btn-action autowidth" (click)="delete()">Submit For Approval</button>
  </div>

</div>
